import React, { Component, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { useCartStore } from "../../store/cartStore";

import HamburgerMenu from 'react-hamburger-menu';

import { View, Text, Image, ActivityIndicator} from "react-native-web";



const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

const HeaderPC = forwardRef((props, ref) => {

  const [open, setOpen] = useState(false);
  const openRef = useRef(false);
  const [items, setItems] = useState(useCartStore.getState().items);

  const currentYear = new Date().getFullYear();
   const navigate = useNavigate();

   const location = useLocation();

   let pathname = location.pathname;

   let _user = null;
   if (props.isSignedin)
   {
      _user = JSON.parse(props.sinUser);
   }


   const user = _user;


  const uniqueItemsCount = useCartStore((state) => state.items.length);



   //  alert(path)

    //console.log('>>> user :: ' + JSON.stringify(user));


   //  user.thumbnail = '/img/black_woman_thumb.png';
   //  user.name = 'Maicha Kabibi';


    const signOut = () => {

      localStorage.removeItem('jwtToken');
      localStorage.removeItem('yeqolaUser');

      setTimeout(() => {
         window.location = "/";
      },100);


    }


    const handleClick = () => {
         global.closeBtnClicked = true;


        let bool;
        if (global.headerBool ===  true)
        {

           bool = false;
           openRef.current = false;
           global.headerBool = false;
        }
        else
        {



           bool = true;
           openRef.current = true;
           global.headerBool = true;
        }

        //let bool = !openRef.current;
        setOpen(bool);



        props.handleMenuClick(bool);
    }


    useImperativeHandle(ref, () => ({
        closeMenu: () => {
            setOpen(false);
            global.headerBool = false;
            openRef.current = false;
        }
    }));



    const setLocale = (lang) => {



  				 localStorage.setItem("language", lang);
  				 i18n.changeLanguage(lang);


  	}



    return (

      <div className="main_header" style={{backgroundColor: '#fff', fontFamily: 'Roboto'}}>


          {props.isSignedin &&
             <div className="main_header_inside">
                   <div className="main_header_inside_left" style={{width: '200px', marginTop: '5px'}}>
                      <a href="/"><img src={'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/yeqola_logo_horiz_white_small.png'} alt="Yeqola Logo" style={{height: '50px'}}/></a>
                   </div>

                   <div className="main_header_inside_right_1" style={{position: 'relative', width: '346px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>

                       {uniqueItemsCount > 0 &&
                         <div style={{position: 'absolute', zIndex: 3, right: '245px', backgroundColor: 'red', color: '#fff', fontSize: '16px', fontWeight: 'bold', borderRadius: '13px', minWidth: '32px', height: '26px', lineHeight: '26px', textAlign: 'center'}}>
                            {uniqueItemsCount}
                         </div>
                       }

                       <a href="/cart">
                          <View style={{cursor: 'pointer', marginTop: '5px', width: '44px', height: '44px', justifyContent: 'center'}}>
                             <Image source={{uri: 'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/cart_empty_white.png'}} style={{width: '44px', height: '44px',}}/>
                          </View>
                        </a>


                        {1===2 &&
                          <View onClick={signOut} style={{cursor: 'pointer', marginLeft: '30px', marginTop: '5px', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                    borderWidth: 1, borderColor: '#fff'}}>
                             <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto',}}>{`Se déconnecter`}</Text>
                          </View>
                        }

                        <div style={{marginRight: '5px', marginLeft: '45px', lineHeight: '55px', color: '#fff'}}>
                           {i18n.language == 'fr' &&
                              <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                            }
                           {i18n.language == 'en' &&
                              <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                            }
                        </div>


                        <a href="/myaccount">
                           <View style={{cursor: 'pointer', marginLeft: '30px', marginTop: '3px', width: '48px', height: '48px', justifyContent: 'center'}}>
                              {user !== null && <Image source={{uri: user.thumbnail}} style={{width: '48px', height: '48px', borderRadius: '24px', border: '1px solid #999'}}/>}
                          </View>
                        </a>





                         <View style={{cursor: 'pointer', marginLeft: '30px', marginTop: '4px', width: '48px', height: '48px', justifyContent: 'center'}}>
                                    <HamburgerMenu
                                      isOpen={openRef.current}
                                      menuClicked={handleClick}
                                      width={48}
                                      height={30}
                                      strokeWidth={2}
                                      rotate={0}
                                      color='white'
                                      borderRadius={0}
                                      animationDuration={0.5}
                                     />
                          </View>


                   </div>

                     <div style={{clear: 'both'}}/>

             </div>
          }

          {!props.isSignedin &&
            <div className="main_header_inside">

                 <div className="main_header_inside_left" style={{width: '200px', marginTop: '5px'}}>
                    <a href="/"><img src={'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/yeqola_logo_horiz_white_small.png'} alt="Yeqola Logo" style={{height: '50px'}}/></a>
                 </div>


                 <div className="main_header_inside_right_1" style={{float: 'right', marginRight: '10px', lineHeight: '55px', color: '#fff'}}>
                   {i18n.language == 'fr' &&
                      <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                   }
                   {i18n.language == 'en' &&
                      <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                   }
                 </div>


                 <div className="main_header_inside_right_1" style={{display: 'flex', position: 'relative', width: '346px', flexDirection: 'row', justifyContent: 'flex-end'}}>

                    {uniqueItemsCount > 0 &&
                      <div style={{position: 'absolute', zIndex: 3, left: '38px', backgroundColor: 'red', color: '#fff', fontSize: '16px', fontWeight: 'bold', borderRadius: '13px', minWidth: '32px', height: '26px', lineHeight: '26px', textAlign: 'center'}}>
                         {uniqueItemsCount}
                      </div>
                    }

                     <a href="/cart">
                        <View style={{cursor: 'pointer', marginTop: '5px', width: '44px', height: '44px', justifyContent: 'center'}}>
                           <Image source={{uri: 'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/cart_empty_white.png'}} style={{width: '44px', height: '44px',}}/>
                        </View>
                      </a>


                      <a href="/signin">
                         <View style={{cursor: 'pointer', marginLeft: '40px', marginTop: '5px', backgroundColor: '#fff', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                             borderWidth: 1, borderColor: '#fff'}}>
                            {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Roboto',}}>{`Sign in`}</Text>}
                            {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Roboto',}}>{`Se connecter`}</Text>}
                         </View>
                       </a>

                     <a href="/signup">
                       <View style={{cursor: 'pointer', marginLeft: '20px', marginTop: '5px', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                  borderWidth: 1, borderColor: '#fff'}}>
                           {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto',}}>{`Sign up`}</Text>}
                           {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto',}}>{`S'enregistrer`}</Text>}
                       </View>
                    </a>

                 </div>

                 <div style={{clear: 'both'}}/>


            </div>
           }



      </div>

    )

});

export default HeaderPC;
